<ng-container *transloco="let t">
  <pxw-input-radio-group
    class="payment-methods"
    name="paymentMethods"
    [label]="t('endOrder.paymentMethodLabel')"
    [options]="paymentMethods()"
    [labelKey]="'name'"
    [(ngModel)]="paymentMethod"
    required
    [displayErrors]="isFormSubmitted()"
    [messages]="{
      required: t('endOrder.paymentMethodRequired'),
    }"
    layout="inline"
  >
    <ng-template #radioItemTemplate let-paymentMethod>
      {{ paymentMethod.name }}

      @if (paymentMethod.discount) {
        <pxw-tag size="xs" type="success" class="payment-discount">
          {{ paymentMethod.discount }}% OFF
        </pxw-tag>
      }
    </ng-template>

    @let selectedPaymentMethod = paymentMethod();

    @if (selectedPaymentMethod) {
      <section class="payment-methods-alerts">
        @if (selectedPaymentMethod.extraCharge && selectedPaymentMethod.extraCharge > 0) {
          <pxw-alert type="warning" display="inline-block" size="sm">
            <span
              [innerHTML]="
                t('endOrder.paymentMethodExtraChargeLabel', {
                  extraCharge: selectedPaymentMethod.extraCharge,
                })
              "
            ></span>
          </pxw-alert>
        }
        @if (selectedPaymentMethod.discount && selectedPaymentMethod.discount > 0) {
          <pxw-alert type="success" display="inline-block" size="sm">
            <span
              [innerHTML]="
                t('endOrder.paymentMethodDiscountLabel', {
                  discount: selectedPaymentMethod.discount,
                })
              "
            ></span>
            <pxw-icon icon="info" #customIcon></pxw-icon>
          </pxw-alert>
        }
        @if (displayLinkInfo() && selectedPaymentMethod.hasLink) {
          <pxw-alert class="payment-method-link-alert" type="info" display="inline-block" size="sm">
            {{ t('endOrder.paymentMethodHasLink' + selectedPaymentMethod.type) }}
            <pxw-icon icon="info" #customIcon></pxw-icon>
          </pxw-alert>
        }
      </section>
    }
  </pxw-input-radio-group>

  @if (shouldDisplayHowMuchField()) {
    <pxw-input-number
      name="howMuch"
      format="currency"
      [label]="t('endOrder.paymentHowMuchLabel')"
      [placeholder]="t('endOrder.paymentHowMuchPlaceholder')"
      [(ngModel)]="howMuch"
      [displayErrors]="isFormSubmitted()"
      required
      [min]="orderFinalAmount()"
      [messages]="{
        min: t('endOrder.paymentHowMuchMin'),
      }"
    />
  }
</ng-container>
